import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl, ConvertDateToDB } from 'src/globals';
import { getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { booking_returndata } from 'src/types/booking_returndata';
import { BusyService } from '../_services/busy.service';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../_services/global.service';
import { MenuItem } from 'primeng/api/menuitem';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { Subscription } from 'rxjs';
import { users_returndata } from 'src/types/user_returndata';
import { tag } from 'src/types/tag';
import { tag_returndata } from 'src/types/tag_returndata';

@Component({
  selector: 'app-partylist',
  templateUrl: './partylist.component.html',
  styleUrls: ['./partylist.component.css']
})
export class PartylistComponent implements OnInit {
  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  selectedItems: any;
  BookingDate: Date;
  BookingDateEnd: Date;
  httpResponse: any;
  navSubscription: Subscription = null;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;

  bcItems: MenuItem[];
  home: MenuItem;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = "-";

  cols: any[];
  chosentags: tag[] = [];
  tags: tag[] = [];

  BookingsTitle: string = "";
  criteria: boolean = false;
  showCriteriaButtonText: string = "Show Criteria";
  searchCriteria: string = "";
  tableFirst: number = 0;
  selectedAction: any = null;

  screenwidth: number = window.innerWidth;
  screenheight: number = window.innerHeight;

  get useMobileView(): boolean {
    if (this.screenwidth <= 768) return true;
    return this.screenwidth <= 1024 && this.screenheight > this.screenwidth;
  }

  constructor(
    private http: HttpClient,
    private appComp: AppComponent,
    private router: Router,
    private messageService: MessageService,
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService,
    private route: ActivatedRoute) {

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse = (response as users_returndata)
      if (this.httpResponse.succeeded) {
        let user = this.httpResponse.data;

        if (getAccess("HOME", user)) {
          this.AccessAllowed = true;
        }

        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
  }

  splitNames(names: string): string[] {
    return names ? names.split(',').map(n => n.trim()).filter(n => n.length > 0) : [];
  }

  maskMobile(MobileIn) {
    if (MobileIn != null && MobileIn.length > 4) {
      let last4 = MobileIn.slice(-4);
      return "**** **** " + last4;
    }
  }

  showBookings() {
    if (this.BookingDateEnd.getTime() > this.BookingDate.getTime() + 31 * 24 * 60 * 60 * 1000) {
      this.messageService.add({severity:'error', summary:'Date Range Error', detail:'The maximum date range allowed is 31 days. Please adjust the end date.'});
      return;
    }

    if (this.BookingDate.getTime() == this.BookingDateEnd.getTime()) {
      this.BookingsTitle = "Party List for " + this.BookingDate.toLocaleDateString('en-GB');
    } else {
      this.BookingsTitle = "Party List between " + this.BookingDate.toLocaleDateString('en-GB') + " and " + this.BookingDateEnd.toLocaleDateString('en-GB');
    }
    this.loadgrid(false);
  }

  showCriteria() {
    this.criteria = !this.criteria;
    this.showCriteriaButtonText = this.criteria ? "Hide Criteria" : "Show Criteria";
  }

  getSearchResults() {
    if (this.searchCriteria.trim() === '') return;
    localStorage.removeItem("SearchResults");
    let crit = this.searchCriteria.trim().replace("/", "-").replace("/", "-");
    crit = encodeURIComponent(crit);
    this.searchCriteria = "";
    this.router.navigate(['/search'], { queryParams: { crit: crit } });
  }

  hideCriteria() {
    this.criteria = false;
    this.showCriteriaButtonText = "Show Criteria";
  }

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);

    addEventListener("resize", () => {
      this.screenwidth = window.innerWidth;
      this.screenheight = window.innerHeight;
    });

    this.cols = [
      { field: 'bookingIdHR', header: 'Sales ID' },
      { field: 'createddateCSV', header: 'Created Date' },
      { field: 'startTimeCSV', header: 'Start Date/Time' },
      { field: 'name', header: 'Name' },
      { field: 'email', header: 'Email' },
      { field: 'phone', header: 'Phone' },
      { field: 'packageName', header: 'Package' },
      { field: 'resourcestring', header: 'Resource' },
      { field: 'guests', header: 'Guests' },
      { field: 'admissions', header: 'Admissions' },
      { field: 'total', header: 'Total' },
      { field: 'outstanding', header: 'Outstanding' },
      { field: 'extraslist', header: 'Extras' },
      { field: 'finalnumbers', header: 'Final Numbers' },
      { field: 'allergy', header: 'Allergy' },
      { field: 'notes', header: 'Notes' },
      { field: 'partynames', header: 'Party Names' },
    ];

    this.loadTags(false);

    // Restore criteria and refresh data when returning from a party booking detail
    if (localStorage.getItem("listScreen") === "TRUE") {
      this.BookingDate = new Date(localStorage.getItem("startdate"));
      this.BookingDateEnd = new Date(localStorage.getItem("enddate"));
      this.BookingsTitle = localStorage.getItem("ListTitle") || "";
      this.chosentags = JSON.parse(localStorage.getItem("ListTags") || "[]");
      this.tableFirst = parseInt(localStorage.getItem("partyListPage") || "0", 10);
      this.CurrencySymbol = localStorage.getItem("Currency") || "GBP";
      localStorage.removeItem("listScreen");
      this.loadgrid(false, false);
      return;
    }

    this.BookingDate = new Date();
    this.BookingDateEnd = new Date();
    this.BookingDateEnd.setDate(this.BookingDateEnd.getDate() + 13);
    this.BookingsTitle = "Party List between " + this.BookingDate.toLocaleDateString('en-GB') + " and " + this.BookingDateEnd.toLocaleDateString('en-GB');

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");

    this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse = (response as venuesettings_returndata)
      if (this.httpResponse.succeeded) {
        localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

        this.httpResponse.data.venueSettings.forEach(element => {
          localStorage.setItem(element.name, element.value);
        });

        this.CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
        this.loadgrid(false, false);
      } else {
        this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
    });
  }

  loadTags(showdisabled: boolean) {
    this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.tags = (response as tag_returndata).data;
    }, error => {
    });
  }

  editdatanew(ID) {
    localStorage.setItem("listScreenBookings", JSON.stringify(this.ListBookings));
    localStorage.setItem("listScreen", "TRUE");
    localStorage.setItem("startdate", this.BookingDate.toJSON());
    localStorage.setItem("enddate", this.BookingDateEnd.toJSON());
    localStorage.setItem("ListTitle", this.BookingsTitle);
    localStorage.setItem("ListTags", JSON.stringify(this.chosentags));
    localStorage.setItem("partyListPage", this.tableFirst.toString());

    this.router.navigateByUrl("/partybooking/" + ID);
  }

  loadgrid(showdisabled: boolean, runClose: boolean = true) {
    let searchCrit = {
      venueid: this.VenueID,
      startdate: ConvertDateToDB(this.BookingDate),
      enddate: ConvertDateToDB(this.BookingDateEnd),
      tags: this.chosentags,
      disabled: showdisabled,
      created: true
    }

    this.busyService.busy();

    this.http.post(bmxurl + "/PartyList", searchCrit).subscribe(response => {
      try {
        this.CreateUpdateResponse = (response as booking_returndata);

        this.ListBookingsGlobal = this.CreateUpdateResponse.data;

        this.hideCriteria();

        this.ListBookings = this.ListBookingsGlobal.filter(obj => obj.inProgress == false);
        this.ListBookings.forEach(element => {
          element.startTimeCSV = this.formatDateForExcel(element.startTime);
          element.createddateCSV = this.formatDateForExcel(element.createddate);
        });

        this.bookingsInProgress = this.ListBookingsGlobal.filter(obj => obj.inProgress == true).length;
        this.totalBookingsToday = this.ListBookingsGlobal.filter(obj => obj.inProgress == false).length;

        this.busyService.idle();
      }
      catch (error) {
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
      }
      finally {
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
      this.busyService.idle();
    });
  }

  customSort(event: any) {
    event.data.sort((a: any, b: any) => {
      let result = 0;

      if (event.field === 'resourcestring') {
        const res1 = a.resourcestring ?? '';
        const res2 = b.resourcestring ?? '';
        result = res1.localeCompare(res2);
        if (result === 0) {
          const d1 = new Date(a.startTime).getTime();
          const d2 = new Date(b.startTime).getTime();
          result = d1 < d2 ? -1 : d1 > d2 ? 1 : 0;
        }
      } else {
        const val1 = a[event.field];
        const val2 = b[event.field];
        if (val1 == null && val2 != null) result = -1;
        else if (val1 != null && val2 == null) result = 1;
        else if (val1 == null && val2 == null) result = 0;
        else if (typeof val1 === 'string' && typeof val2 === 'string') result = val1.localeCompare(val2);
        else result = val1 < val2 ? -1 : val1 > val2 ? 1 : 0;
      }

      return event.order * result;
    });
  }

  formatDateForExcel(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = ('0' + d.getUTCDate()).slice(-2);
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const year = d.getUTCFullYear();
    const hours = ('0' + d.getUTCHours()).slice(-2);
    const minutes = ('0' + d.getUTCMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
}
